module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/delete-image/delete-image.component.scss
// module id = ./src/app/delete-image/delete-image.component.scss
// module chunks = main